import { shallowEqual, useSelector } from 'react-redux';
import { TOGGLE_NAMES } from 'platform/utilities/feature-toggles';
import { ANALYTICS_FIELD_MAP } from '../constants';
import {
  selectEditedFormField,
  selectVAPServiceTransaction,
} from '../selectors';

/**
 * Everything the edit view used to receive from connect(), as a hook.
 *
 * PORT NOTE: mapStateToProps also returned data, activeEditView, editViewData
 * and emptyMailingAddress. The class never read any of the four — they were
 * declared in propTypes and left unused — so they are not selected here.
 *
 * PORT NOTE: as in useProfileInformationFieldData, the store reads are split
 * rather than combined into one selector, because selectVAPServiceTransaction
 * builds a fresh wrapper object on every call and would fail its equality check
 * on every dispatched action.
 */
export const useEditViewData = fieldName => {
  // shallowEqual is required here: selectVAPServiceTransaction builds a fresh
  // object on every call.
  const { transaction, transactionRequest } = useSelector(
    state => selectVAPServiceTransaction(state, fieldName),
    shallowEqual,
  );

  const field = useSelector(state => selectEditedFormField(state, fieldName));

  const intlMobileConfirmModalEnabled = useSelector(
    // Optional chains since test contexts might not provide the objects
    state => state?.vapService?.intlMobileConfirmModal?.isOpen || false,
  );

  const useProfileServiceRefactor = useSelector(
    state =>
      state.featureToggles?.[TOGGLE_NAMES.cveProfileServiceRefactor] || false,
  );

  return {
    analyticsSectionName: ANALYTICS_FIELD_MAP[fieldName],
    field,
    intlMobileConfirmModalEnabled,
    transaction,
    transactionRequest,
    useProfileServiceRefactor,
  };
};
